﻿import React from 'react';
import {Grid} from "@mui/material";
import {styled} from "@mui/styles";

const Root = styled(Grid)(() => ({
  position: 'absolute',
  right: '0em',
  top: '0em',
  height: '100%',
  width: 'auto',
}));

// Using interface extends PropsWithChildren<React.ComponentPropsWithoutRef<'div'>> doesn't work properly because
//  PropsWithChildren and ComponentPropsWithoutRef are types and don't properly intersect and keep the children on
//  extension. The children prop also isn't being extended properly when extending just ComponentPropsWithoutRef.
//  I can't seem to find the exact reasoning, however this reference outlines which combinations work properly
//  https://react-typescript-cheatsheet.netlify.app/docs/basic/getting-started/basic_type_example#useful-table-for-types-vs-interfaces
//  Using a type with intersections seems to work as intended
type ActionsMenuFlexAbsoluteContainerProps = React.ComponentPropsWithoutRef<'div'>;
// interface ActionsMenuFlexAbsoluteContainerProps extends React.ComponentPropsWithoutRef<'div'> // doesn't work
// interface ActionsMenuFlexAbsoluteContainerProps extends PropsWithChildren<React.ComponentPropsWithoutRef<'div'>> // also doesn't work
// const ActionsMenuFlexAbsoluteContainer = ({ children, ...rest}: PropsWithChildren<ActionsMenuFlexAbsoluteContainerProps>) => { // seems like it works, but actually doesn't

// Using React.FC<blah> is equivalent to typing the destructured props and is actively discouraged in older versions
//  of react. In order to save some typing, I'm not going to use it anymore.
//  https://react-typescript-cheatsheet.netlify.app/docs/basic/getting-started/function_components/

/**
 * MUI Grid component styled in the SecurSpace way. Holds and positions contents absolutely to the right of the view
 * @param children children passed through to the internal Grid component
 * @param rest The rest of the Grid props that will be passed through to the internal Grid component
 * @constructor
 */
const ActionsMenuFlexAbsoluteContainer = ({ children, ...rest}: ActionsMenuFlexAbsoluteContainerProps) => {
  return <Root container justifyContent={'flex-end'} alignItems={'center'} {...rest}>
    { children }
  </Root>
}

export { ActionsMenuFlexAbsoluteContainer };
